import { useState, useRef, useEffect } from "react";
import { useDesktop } from "../../hooks";
import { useDispatch } from "react-redux";
import { motion } from "framer-motion";
import { screenTop } from "../../services/topSlice";
import { IconContext } from "react-icons";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { Outlet, NavLink, Link, useLocation } from "react-router-dom";
import "../../styles/dashboard.css";
import { logout } from "../../services/userSlice";
import { auth } from "../../firebaseSetup";

interface top {
  top: string;
}

const Dashboard = () => {
  const { pathname } = useLocation();

  const [dropdown, setdropdown] = useState(false);
  const handleClick = () => {
    setdropdown((state) => !state);
  };

  const logoutOfApp = () => {
    // dispatch to the store with the logout action
    dispatch(logout());
    // sign out function from firebase
    auth.signOut();
  };

  let activeClassName = "dashboard-desktop-link";

  //setting the height of the dashboard nav based on the height of the elements content
  const [style, setStyle] = useState({
    height: "auto",
    display:
      pathname === "/dashboard/videoplayer" ||
      pathname === "/dashboard/videoplayer/"
        ? "none"
        : "block",
  });
  const [top, setTop] = useState({
    top: "0px",
  });
  const sectionRef = useRef<HTMLElement>(null);
  const dispatch = useDispatch();
  const handleTop = (top: top) => {
    dispatch(screenTop(top));
  };
  handleTop(top);
  // how it's used
  useEffect(() => {
    if (undefined !== sectionRef.current?.children) {
      const getNode = sectionRef.current?.children;
      // @ts-ignore
      const navOffset = getNode[1]?.offsetTop;
      const sectHeight = getNode[2]?.clientHeight;
      const newHeight = sectHeight + 50;
      // 👈️ element here
      setStyle((prevStyle) => {
        return {
          ...prevStyle,
          height: `${newHeight}px`,
        };
      });
      const newTop = navOffset - 32;
      setTop((prevTop) => {
        return {
          ...prevTop,
          top: `${newTop}px`,
        };
      });
    }
  }, [pathname]);

  return (
    <motion.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0.4 }}
      transition={{ duration: 0.5 }}
      className="dashboard"
      ref={sectionRef}
    >
      <IconContext.Provider value={{ className: "dashboard-icons" }}>
        <section
          className="dashboard-hero"
          style={{
            display: pathname === "/dashboard/videoplayer" ? "none" : "block",
          }}
        >
          <div className="dashboard-hero-showcase">
            <h2>My Learning</h2>
            {useDesktop() >= 801 && (
              <div className="dashboard-hero-searchbar">
                <input
                  type="text"
                  placeholder="search for a course"
                />
                <span>Search</span>
              </div>
            )}
          </div>
        </section>
        <section
          className="dashboard-nav"
          style={{
            display:
              pathname === "/dashboard/videoplayer" ||
              pathname === "/dashboard/videoplayer/"
                ? "none"
                : "block",
          }}
        >
          {useDesktop() < 1024 && (
            <div onClick={handleClick}>
              <h3>
                {pathname === "/dashboard" || pathname === "/dashboard/"
                  ? "All Courses"
                  : pathname.substring(11).replace("-", " ")}
              </h3>
              {!dropdown && <IoIosArrowDown className="dash-arrow" />}
              {dropdown && <IoIosArrowUp className="dash-arrow" />}
            </div>
          )}

          {useDesktop() < 1024 && dropdown && (
            <ul
              className="dashboard-mobile-nav"
              onClick={handleClick}
              style={{
                display:
                  pathname === "/dashboard/videoplayer" ||
                  pathname === "/dashboard/videoplayer/"
                    ? "none"
                    : "block",
              }}
            >
              <li>
                <Link to="all-courses">All Courses</Link>
              </li>
              <li>
                <Link to="in-progress">In Progress</Link>
              </li>
              <li>
                <Link to="completed">Completed</Link>
              </li>
              <li>
                <Link to="wishlist">Wishlist</Link>
              </li>
              <li>
                <Link to="my-account">My Account</Link>
              </li>
            </ul>
          )}

          {useDesktop() >= 1024 && (
            <ul
              className="dashboard-desktop-nav"
              style={style}
            >
              <li>
                <NavLink
                  className={({ isActive }) =>
                    isActive ? activeClassName : undefined
                  }
                  to=""
                  end
                >
                  All Courses
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={({ isActive }) =>
                    isActive ? activeClassName : undefined
                  }
                  to="in-progress"
                >
                  In Progress
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={({ isActive }) =>
                    isActive ? activeClassName : undefined
                  }
                  to="completed"
                >
                  Completed
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={({ isActive }) =>
                    isActive ? activeClassName : undefined
                  }
                  to="wishlist"
                >
                  Wishlist
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={({ isActive }) =>
                    isActive ? activeClassName : undefined
                  }
                  to="my-account"
                >
                  My Account
                </NavLink>
              </li>
              <li>
                <a onClick={logoutOfApp}>
                  Logout{" "}
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.66667 14.6666H3.33333C2.59695 14.6666 2 14.0696 2 13.3333V2.66659C2 1.93021 2.59695 1.33325 3.33333 1.33325H6.66667"
                      stroke="#494949"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M11.332 10.6666L13.9987 7.99992L11.332 5.33325"
                      stroke="#494949"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M14 8H6"
                      stroke="#494949"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </a>
              </li>
            </ul>
          )}
        </section>
      </IconContext.Provider>
      <Outlet />
    </motion.main>
  );
};

export default Dashboard;
